import React from 'react';
import { createCleanMarkup, isPreview } from '../../../../../../utils/common';
import StepContentPanel from '../../../StepContentPanel';
import { CmsContent, Room } from '../../../proctorStepsTypes';
import ThankYouPreview from './ThankYouPreview';
import { useStateValue } from '../../../../../../context/AppContext';
import Messaging from '../../../../../../context/Messaging';

interface EndTestProps {
  room: Room;
  cmsContent: CmsContent;
  outerStep: number;
}

const EndTest: React.FC<EndTestProps> = ({ room, cmsContent, outerStep }) => {
  const { user } = useStateValue();
  // Check if the User is in preview mode.
  const isPreviewMode = isPreview(user?.role, user?.mode, user?.active);
  const endTestContent = cmsContent?.steps?.find((n) => n.step_number === outerStep);
  const endTestText = <div dangerouslySetInnerHTML={createCleanMarkup(endTestContent?.main_panel_content)} />;
  const detailPanelData = isPreviewMode ? (
    <Messaging dynamic preview section='wizard.thankYou.imgDesc' />
  ) : (
    <div dangerouslySetInnerHTML={createCleanMarkup(endTestContent?.detail_panel_content)} />
  );
  const content = {
    main_panel_header: endTestContent?.main_panel_header,
    main_panel_content: endTestText,
    detail_panel_content: detailPanelData,
  };

  return (
    <StepContentPanel
      room={room}
      heading='Thank you!'
      invertStyle
      showStepCompletePanel
      content={content}
      desc={
        <div className='row row-eq-height'>
          {isPreviewMode ? <ThankYouPreview /> : <div className='col-xs-12 py-3'>{content.main_panel_content}</div>}
        </div>
      }
      img={<div className='thankYou-svg step-illustration-img mt-4' />}
      imgDesc='Let your coordinator know your room finished testing.'
    />
  );
};

export default EndTest;
